import { servicesOrderWizardSteps } from "../../configs/constraints";
import ACTIONS from "../actions/types";

const initialState = {
  isFetchingServiceOrdersList: false,
  serviceOrdersList: [],
  serviceOrdersTotal: 0,
  isFetchingServiceSolutionsList: false,
  isAddingNewServiceOrder: false,
  isAddingServiceOrderAttachments: false,
  serviceSolutionsList: [],
  isFetchingServiceOrderAttachmentsList: false,
  serviceOrderAttachmentsList: [],
  isFetchingSelectedServiceOrderDetails: false,
  selectedServiceOrderDetails: {},
  wizardActiveStep: servicesOrderWizardSteps.DEVICE_INFO,
  isReplacingDeviceLoading: false,
  serviceCausesList: [],
  isFetchingServiceCausesList: false,
  targetReplacementDevice: null,
  allOwnersList: [],
};
const ServiceOrdersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST_START:
      return {
        ...state,
        isFetchingServiceOrdersList: true,
      };

    case ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST:
      return {
        ...state,
        isFetchingServiceOrdersList: false,
        serviceOrdersList: [...payload.data],
        serviceOrdersTotal: payload.total,
      };

    case ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDERS_LIST_FAILURE:
      return {
        ...state,
        isFetchingServiceOrdersList: false,
        serviceOrdersList: [],
      };
    case ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDER_SOLUTIONS_LIST_START:
      return {
        ...state,
        isFetchingServiceSolutionsList: true,
      };

    case ACTIONS.SERVICE_ORDERS.GET_ALL_SERVICE_ORDER_OWNER_START:
      return {
        ...state,
        allOwnersList: [],
        isFetchingOwnersList: true,
      };
    case ACTIONS.SERVICE_ORDERS.GET_ALL_SERVICE_ORDER_OWNER_SUCCESS:
      return {
        ...state,
        allOwnersList: [...payload],
        isFetchingOwnersList: false,
      };
    case ACTIONS.SERVICE_ORDERS.GET_ALL_SERVICE_ORDER_OWNER_FAILURE:
      return {
        ...state,
        allOwnersList: [],
        isFetchingOwnersList: false,
      };

    case ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDER_SOLUTIONS_LIST:
      return {
        ...state,
        isFetchingServiceSolutionsList: false,
        serviceSolutionsList: [...payload],
      };

    case ACTIONS.SERVICE_ORDERS.FETCH_SERVICE_ORDER_SOLUTIONS_LIST_LIST_FAILURE:
      return {
        ...state,
        isFetchingServiceSolutionsList: false,
        serviceSolutionsList: [],
      };

    case ACTIONS.SERVICE_ORDERS.ADD_NEW_SERVICE_ORDER_START:
      return {
        ...state,
        isAddingNewServiceOrder: true,
      };

    case ACTIONS.SERVICE_ORDERS.ADD_NEW_SERVICE_ORDER:
      return {
        ...state,
        isAddingNewServiceOrder: false,
      };

    case ACTIONS.SERVICE_ORDERS.ADD_NEW_SERVICE_ORDER_FAILURE:
      return {
        ...state,
        isAddingNewServiceOrder: false,
      };

    case ACTIONS.SERVICE_ORDERS.ADD_SERVICE_ORDER_ATTACHMENT_START:
      return {
        ...state,
        isAddingServiceOrderAttachments: true,
      };

    case ACTIONS.SERVICE_ORDERS.ADD_SERVICE_ORDER_ATTACHMENT:
      return {
        ...state,
        isAddingServiceOrderAttachments: false,
      };

    case ACTIONS.SERVICE_ORDERS.ADD_SERVICE_ORDER_ATTACHMENT_FAILURE:
      return {
        ...state,
        isAddingServiceOrderAttachments: false,
      };

    case ACTIONS.SERVICE_ORDERS.SERVICE_ORDERS__FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_START:
      return {
        ...state,
        isFetchingServiceOrderAttachmentsList: true,
        serviceOrderAttachmentsList: [],
      };
    case ACTIONS.SERVICE_ORDERS.SERVICE_ORDERS__FETCH_ALL_SEVICE_ORDER_ATTACHMENTS:
      return {
        ...state,
        isFetchingServiceOrderAttachmentsList: false,
        serviceOrderAttachmentsList: [...payload],
      };
    case ACTIONS.SERVICE_ORDERS.SERVICE_ORDERS__FETCH_ALL_SEVICE_ORDER_ATTACHMENTS_FAILURE:
      return {
        ...state,
        isFetchingServiceOrderAttachmentsList: false,
        serviceOrderAttachmentsList: [],
      };
    case ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS_START:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: true,
        selectedServiceOrderDetails: {},
      };
    case ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
        selectedServiceOrderDetails: { ...payload },
      };
    case ACTIONS.SERVICE_ORDERS.FETCH_SEVICE_ORDER_DETAILS_FAILURE:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
        selectedServiceOrderDetails: {},
      };

    case ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER_START:
      return {
        ...state,
        isFetchingServiceSolutionsList: true,
      };
    case ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER:
      return {
        ...state,
        isFetchingServiceSolutionsList: false,
        serviceOrdersList: state.serviceOrdersList.filter((s) => s._id !== payload._id),
      };
    case ACTIONS.SERVICE_ORDERS.DELETE_DEVICE_SERVICE_ORDER_FAILURE:
      return {
        ...state,
        isFetchingServiceSolutionsList: false,
      };
    case ACTIONS.SERVICE_ORDERS.SET_SERVICE_ORDER_ACTIVE_STEP:
      return {
        ...state,
        wizardActiveStep: payload,
      };

    case ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_START:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: true,
      };
    case ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
        selectedServiceOrderDetails:
          "beforeImages" in payload
            ? { ...state.selectedServiceOrderDetails, beforeImages: [...payload.beforeImages] }
            : { ...state.selectedServiceOrderDetails },
      };
    case ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_BEFORE_IMAGE_ATTACHMENT_FAILURE:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
      };
    case ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_START:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: true,
      };
    case ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
        selectedServiceOrderDetails:
          "afterImages" in payload
            ? { ...state.selectedServiceOrderDetails, afterImages: [...payload.afterImages] }
            : { ...state.selectedServiceOrderDetails },
      };
    case ACTIONS.SERVICE_ORDERS.UPDATE_SERVICE_ORDER_AFTER_IMAGE_ATTACHMENT_FAILURE:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
      };

    case ACTIONS.SERVICE_ORDERS.EDIT_SERVICE_ORDER_DATA_START:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: true,
      };
    case ACTIONS.SERVICE_ORDERS.EDIT_SERVICE_ORDER_DATA:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
        selectedServiceOrderDetails: { ...payload },
      };
    case ACTIONS.SERVICE_ORDERS.EDIT_SERVICE_ORDER_DATA_FAILURE:
      return {
        ...state,
        isFetchingSelectedServiceOrderDetails: false,
      };

    case ACTIONS.SERVICE_ORDERS.REPACE_DEVICE_BY_IDS_START:
      return {
        ...state,
        isReplacingDeviceLoading: true,
      };
    case ACTIONS.SERVICE_ORDERS.REPACE_DEVICE_BY_IDS:
      return {
        ...state,
        isReplacingDeviceLoading: false,
      };
    case ACTIONS.SERVICE_ORDERS.REPACE_DEVICE_BY_IDS_FAILURE:
      return {
        ...state,
        isReplacingDeviceLoading: false,
      };

    case ACTIONS.SERVICE_ORDERS.GET_SERVICE_CAUSES_START:
      return {
        ...state,
        serviceCausesList: [],
        isFetchingServiceCausesList: true,
      };
    case ACTIONS.SERVICE_ORDERS.GET_SERVICE_CAUSES:
      return {
        ...state,
        serviceCausesList: [...payload],
        isFetchingServiceCausesList: false,
      };
    case ACTIONS.SERVICE_ORDERS.GET_SERVICE_CAUSES_FAILURE:
      return {
        ...state,
        serviceCausesList: [],
        isFetchingServiceCausesList: false,
      };
    case ACTIONS.SERVICE_ORDERS.SET_TARGET_REPLACEMENT_DEVICE:
      return {
        ...state,
        targetReplacementDevice: payload,
      };

    default:
      return { ...state };
  }
};
export default ServiceOrdersReducer;
